<div class="column">
    <div class="row">
        <div class="column small-12 large-5">
            <sbw-select-field name="vehicleType" [control]="vehicleTypeControl" label="{{'VEHICLE' | resource}}"
                [items]="vehicleItems" [errorMessage]="errorVehicle ? ' ' : ''"></sbw-select-field> <!-- TODO: Figure out what to do with error message instead of empty space string -->
        </div>
        <div class="column small-12 large-4 end" *ngIf="isVehicleSelected && allowedTrailers.length > 0">
            <sbw-select-field name="trailerType" [control]="trailerTypeControl" label="{{'TRAILER' | resource}}"
                [items]="trailerItems" [errorMessage]="errorTrailer ? ' ' : ''"></sbw-select-field> <!-- TODO: Figure out what to do with error message instead of empty space string -->
        </div>
        <div *ngIf="supportMultiple && isVehicleSelected" class="column small-12 large-3 end">
            <sbw-select-field name="vehicleCount" [control]="vehicleCountControl" label="{{'VEHICLE_COUNT' | resource}}"
                [items]="vehicleCountItems"></sbw-select-field>
        </div>
    </div>
</div>
